import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 
import DeleteIcon from '@material-ui/icons/DeleteOutlineOutlined';

import CartService from '../../../../models/CartService';

import breakdownStyles from './additionalServicesPaymentsBreakdown.module.css';
import commonStyles from '../../../common/common.module.css';
import { getAdditionalServiceName } from '../../../../utils/additionalServices';
import { formatCurrency } from '../../../../utils/currencyFormatter';

const iconFontSize = 20;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  });

interface additionalServicesPaymentsBreakdownProps {
  classes: any;
  additionalServices: CartService[];
  remainDue: number;
  totalPaid: number;
  totalPending: number;
  deleteService: Function;
};

const additionalServicesPaymentsBreakdown = (props: additionalServicesPaymentsBreakdownProps) => {

  const { classes } = props;

  return (
    <Fragment>
      <div className={ `${ commonStyles.wrapper } ${ breakdownStyles.wrapper }` }>
        <h3 className={commonStyles.header}> Table</h3>
        <MaterialTable
          data={ props.additionalServices }
          
          localization = {{
            header: { actions: '' }
          }}
      
          columns={[
            { title: 'Fee', field: '', cellStyle: { width: '190px' , paddingRight: 0, whiteSpace: 'nowrap'},
              render: (rowData: CartService) => { 
                if (rowData.type === 'other' || rowData.type === 'gha_adjust') {
                  return (<span>{ getAdditionalServiceName(rowData.type) }: {rowData.params.reason}</span>);
                }
                if (rowData.type === 'certified_manifest_charge' && rowData.params.transaction_date) {
                  const formattedDate = rowData.params.transaction_date;
                  return (<span>{ getAdditionalServiceName(rowData.type) }: {formattedDate.substring(4,6)}/{formattedDate.substring(6,8)}/{formattedDate.substring(0,4)}</span>);
                }
                return (<span>{ getAdditionalServiceName(rowData.type) }</span>);
              }
            },
            { title: 'Due', field: 'remain', type:'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0, whiteSpace: 'nowrap' } },
            { title: 'Pending', field: 'pending', type: 'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0, whiteSpace: 'nowrap'  } },
            { title: 'Paid', field: 'paid', type: 'currency', headerStyle: { paddingTop: '10px' }, cellStyle: { width: '110px', paddingRight: 0, whiteSpace: 'nowrap' } },
            { title: 'Additional Info', field: 'additional_info', headerStyle: { paddingTop: '10px'}, cellStyle: { paddingRight: 0,} }
          ]}

          actions = {[
            rowData => ({
              icon: 'delete',
              onClick: ()=> {}
            })
          ]}

          components = {{
            Action: properties => (
              <span>
                { (properties.data.type !== 'import_service' && properties.data.type !== 'storage_fee'  && properties.data.type !== 'return_fee' ) && 
                  <DeleteIcon 
                    className={ classes.materialIcon }
                    onClick={(event) => props.deleteService(properties.data.type, properties.data.params.reason)}				
                  />	
                }
              </span>
              ),
            Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>
          }}

          options={{
            selection: false,
            paging: false,
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            rowStyle: {
              height: '30px'
            },
            showTitle: false,
            toolbar: false,
            sorting: false
          }}
        />	
        <div className={ breakdownStyles.totalWrapper }>
          <div className={ breakdownStyles.totalCol }></div>
          <div className={ breakdownStyles.totalCol }>{ formatCurrency(props.remainDue, 2, '$') }</div>
          <div className={ breakdownStyles.totalCol }>{ formatCurrency(props.totalPending, 2, '$') }</div>
          <div className={ breakdownStyles.totalCol }>{ formatCurrency(props.totalPaid, 2, '$') }</div>
        </div>
      </div>
    </Fragment>
  );
}

export default withStyles(styles)(additionalServicesPaymentsBreakdown);